import TrialPanel from 'devextreme/core/trial_panel';
TrialPanel.registerTrialPanelComponents();
